import React,{useState,useEffect}from 'react'
import { Table,Space,Radio, Flex,} from 'antd';
import {useFinanceSubTypeListQuery,} from '../../store/ReactWebSiteApi';
import BalanceTypeAdd from './BalanceTypeAdd';
import BalanceTypeEdit from './BalanceTypeEdit';
import BalanceTypeDel from './BalanceTypeDel';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
function BalanceTypeList(props) {   
    const [query,setQuery] = useState({
        efst_e_id:localStorage.getItem('e_id'),
        efst_finance_type_id:'',
        efst_state:'2',
    })    
    const {data,isSuccess} = useFinanceSubTypeListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);                
                const newArr = data.Result.map(item => {
                    const {efst_id:key,efst_finance_type_id,efst_name,efst_content,efst_uname,efst_ctime,efst_update_ctime,efst_update_uname,num,ed_name,efst_state} = item;
                    let type = ''
                        switch (efst_finance_type_id) {
                            case '1'://销售收入
                            type = '团队收入'
                                break;
                            case '2'://成本支出
                            type = '团队支出'
                                break;
                            case '3'://费用支出
                            type = '费用支出'
                                break;
                            case '4'://其他收入
                            type = '其他收入'
                                break;
                            case '5'://其他支出
                            type = '其他支出'
                                break;              
                            default:
                                break;
                        }
                    return item = {key,efst_finance_type_id,efst_name,efst_content,efst_uname,efst_ctime,efst_update_ctime,efst_update_uname,num,ed_name,type,efst_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.efst_ctime;
                    let bTimeString = b.efst_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])     


    const columns = [    
        {
            key: 'type',
            title: '科目',
            dataIndex: 'type',
            width:'10%',           
        },                                          
        {
            key: 'type',
            title: '类型名称',
            dataIndex: 'efst_name',
            width:'10%',            
        },                                          
        {
            key: 'efst_content',
            title: '备注',
            dataIndex: 'efst_content',
            width:'10%',
        },                                 
        {
            key: 'num',
            title: '收支数量',
            dataIndex: 'num',
            width:'10%',
        },   
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',
            width:'10%',
        },                                            
                                                  
        // {
        //     key: 'time',
        //     title: '操作记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>新建时间：{record.efst_ctime + record.efst_uname}</div>
        //             <div>修改时间：{record.efst_update_ctime + record.efst_update_uname}</div>
        //         </>
        //     },
        //     width:'10%',
        // },
        {
            key: 'action',
            width:'10%',
            title: '操作',
            render: (_, record) => {                
                return <>
                    <Space>                        
                        <BalanceTypeEdit
                            efst_id={record.key}
                            title={props.title}                            
                            efst_state={record.efst_state}
                        />
                        <BalanceTypeDel 
                            efst_id={record.key} 
                            num={record.num}
                            efst_state={record.efst_state}
                        />
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main t1='收支类型'>
            {query.efst_state==='2' ? <Flex justify='space-between' align='center'>
                <Space size={60}>
                    <BalanceTypeAdd 
                        efst_finance_type_id={props.efst_finance_type_id}
                        title={props.title}
                    />
                    <div>
                        <span>科目：</span>
                        <Radio.Group
                            value={localStorage.getItem('task_etu_user_id')?'':localStorage.getItem('task_et_status')}
                            onChange={(e) => {
                                localStorage.setItem('task_action','search')
                                localStorage.setItem('task_etu_user_id','')
                                localStorage.setItem('task_et_status',e.target.value)
                                localStorage.setItem('task_et_name','')
                                localStorage.setItem('task_et_uid',localStorage.getItem('eu_id'))
                                localStorage.setItem('task_et_e_date','')
                                localStorage.setItem('task_et_s_date','') 
                                setQuery(prevState=>({...prevState,
                                    efst_finance_type_id:e.target.value,
                                }))  
                            }}
                        >
                            <Radio.Button value='0'>全部</Radio.Button>
                            <Radio.Button value='1'>团队收入</Radio.Button>
                            <Radio.Button value='2'>团队支出</Radio.Button>
                            <Radio.Button value='3'>费用支出</Radio.Button>
                            <Radio.Button value='4'>其他收入</Radio.Button>
                            <Radio.Button value='5'>其他支出</Radio.Button>
                        </Radio.Group>
                    </div>
                </Space>
                <a 
                    style={{
                        marginRight:"20px",
                        fontSize:"18px"
                    }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,efst_state:'1'}))
                    }}
                ><DeleteOutlined /> 已删除收支类型</a>
            </Flex>:<Flex>
                        <a 
                            style={{
                                fontSize:"18px"
                                }}
                            onClick={() => {
                                setQuery(prevState=>({...prevState,efst_state:'2'}))
                            }}
                        ><LogoutOutlined /> 未删除收支类型</a>
                    </Flex>}
            <Table columns={columns} dataSource={list} style={{marginTop:"20px"}}></Table>
        </Main>
    )
}

export default BalanceTypeList